import React, { useEffect, useState } from "react";
import Header from "../components/layout/header.jsx";
import { MdOutlineDescription } from "react-icons/md";
import { BsCalendar2Date } from "react-icons/bs";
import {
  FaMapPin,
  FaRupeeSign,
  FaSearch,
  FaShoppingBag,
  FaCalendarAlt,
} from "react-icons/fa";
import { FcHighPriority } from "react-icons/fc";
import { backendApi } from "../api/apiService.js";
import ApplyNowPopup from "./applyPopup.jsx";
import { setStoredLogo } from "../utils/logo";

function ApplyNow() {
  const [jobList, setJobList] = useState([]);
  const [applyResume, setApplyResume] = useState(false);
  const [positionData, setPositionData] = useState("");
  const [searchParams, setSearchParams] = useState("");
  const [jobSkills, setJobSkills] = useState([]);
  const [siteDetails, setSiteDetails] = useState([]);
  const [searchMode, setSearchMode] = useState(false);

  useEffect(() => {
    // openingInit();
    getSiteDetails();
    // getSearchData(window.location.pathname.split("/").pop(), "");
  }, []);

  const getSearchData = (siteId, search, param) => {
    try {
      setSearchMode(param);
      const api = {
        functionName: "jobSearching",
        site_id: siteId,
        params: search,
      };
      backendApi(api).then((data) => {
        console.log("data", data);
        setJobList(data.dataSet);
      });
    } catch (e) {
      console.error("Error found", e);
    }
  };
  const getSiteDetails = () => {
    const currentUrl = window.location.href;

    // Extract site ID from the URL
    const siteIdMatch = currentUrl.match(/\/(\d+)\/?$/);
    const siteId = siteIdMatch ? siteIdMatch[1] : "";

    // Extract web URL from the URL
    let webUrlMatch = currentUrl.match(/^(https?:\/\/[^\/]+)\/?/);
    let webUrl = webUrlMatch ? webUrlMatch[1] : "";
    if (siteId !== "") webUrl = "";
    else siteId = "";
    var req = {
      functionName: "getSiteDetails",
      site_id: siteId ? siteId : "",
      web_url: webUrl ? webUrl : "",
    };
    console.log("siteDetailsReq", req);
    backendApi(req).then((response) => {
      console.log("siteDetailsResponse", response);
      if (response.success === "1") {
        setSiteDetails(response.dataSet);
        if (response.dataSet.length > 0) {
          // setShowCareers(true);
          setStoredLogo(response.dataSet[0].company_logo);
        }
      } else {
        console.log("Error while fetching site details");
        return false;
      }
    });
  };
  useEffect(() => {
    if (siteDetails.length == 1) {
      getSearchData(siteDetails[0].id, "", false);
      openingInit(siteDetails[0].id);
    }
  }, [siteDetails]);

  useEffect(() => {
    let link = window.location.pathname.split("/");
    if (link[link.length - 2] !== "careers" && searchMode === false) {
      console.log("jobList", jobList);
      let jobId = link[link.length - 2];
      let filteredJob = jobList.filter((obj) => obj.id == jobId);
      if (filteredJob.length === 1) applyFunction(filteredJob[0]);
    }
  }, [jobList]);

  const openingInit = (siteId) => {
    var req = {
      functionName: "job_opening_init",
      site_id: siteId,
    };
    backendApi(req).then((response) => {
      const transformedOptions = response.skills.map((skill, index) => ({
        value: index + 1,
        label: skill.skill_name,
      }));
      setJobSkills(transformedOptions);
    });
  };

  function formatDateToCustomFormat(dateString) {
    const options = {
      year: "numeric",
      month: "short",
      day: "numeric",
    };

    return new Date(dateString).toLocaleDateString("en-GB", options);
  }
  const applyFunction = (data) => {
    setPositionData(data);
    setApplyResume(true);
  };
  return (
    <>
      <Header />
      <div className="xilliContent">
        <div className="row m-0">
          <div className="col-md-10 mx-auto">
            <div className="xilliWrap w-100">
              <div className="xilliBrudcrb">
                <h1 className="text-left pb-0 career-head">Careers</h1>
                <div
                  className="xilliSearch xilliSearchLarge"
                  style={{ marginBottom: "20px" }}
                >
                  <div className="search-local w-100 mw-100">
                    <div className="icon">
                      <FaSearch />
                    </div>
                    <input
                      type="text"
                      placeholder="Enter Skills / Designations / Companies "
                      value={searchParams}
                      onChange={(e) => setSearchParams(e.target.value)}
                      // onKeyDown={handleKeyPress}
                    />
                    <button className="search-local-button"
                      onClick={(e) => {
                        e.preventDefault();
                        getSearchData(siteDetails[0]?.id, searchParams, true);
                        //   searchCandidates();
                      }}
                    >
                      <a href="" className="text-light">Search</a>
                      <ion-icon
                        name="search-outline"
                        className="search-icon"
                      ></ion-icon>
                    </button>
                  </div>
                </div>
              </div>
              <div className="row  justify-content-center">
                <div className="col-md-12 mx-auto">
                  {jobList.map((candidate, index) => {
                    return (
                      <div>
                        {candidate.is_active === 1 && (
                          <div className="crnRes">
                            <div className="row">
                              <div className="col-md-7">
                                <h4 className="mb-2">{candidate.summary}</h4>
                                <p className="mb-1">
                                  <span>
                                    <MdOutlineDescription title="description" />{" "}
                                    {candidate.description}
                                  </span>
                                </p>
                                <p className="d-lg-flex align-items-center">
                                  <span className="d-flex-align-items-center me-2">
                                    <BsCalendar2Date
                                      title="start date"
                                      className="me-1 mb-1"
                                    />
                                    {formatDateToCustomFormat(
                                      candidate.start_date
                                    )}{" "}
                                  </span>
                                  <span className="d-none d-lg-block">|</span>
                                  <span className="d-flex-align-items-center me-2">
                                    <BsCalendar2Date
                                      title="end date"
                                      className="me-1 mb-1"
                                    />
                                    {formatDateToCustomFormat(
                                      candidate.end_date
                                    )}{" "}
                                  </span>
                                  <span className="d-none d-lg-block">|</span>
                                  <span className="d-flex align-items-center">
                                    <FaCalendarAlt
                                      title="experience"
                                      className="me-1"
                                    />{" "}
                                    {candidate.experiance
                                      ? candidate.experiance
                                      : 0}{" "}
                                    Years{" "}
                                  </span>
                                  <span className="d-none d-lg-block">|</span>
                                  <span className="align-items-center pl-0 d-flex">
                                    <FaShoppingBag
                                      title="experience"
                                      className="me-1 ml-2"
                                    />{" "}
                                    Job Type:{" "}
                                    {candidate.job_type
                                      ? candidate.job_type
                                      : 0}
                                  </span>
                                  <span className="d-none d-lg-block">|</span>
                                  <span className="status-condition-text">
                                    Status :{" "}
                                    {candidate.status
                                      ? candidate.status
                                      : " Not Available"}{" "}
                                  </span>
                                </p>
                                <div className="crmExpn py-2 mb-0">
                                  <p>
                                    {/* <span>
                                      {" "}
                                      CTC : <FaRupeeSign />{" "}
                                      {candidate.salary ? candidate.salary : 0}
                                    </span>
                                    | */}
                                  </p>
                                  <p>
                                    {/* |
                                    <span>
                                      <FcHighPriority title="priority" />{" "}
                                      {candidate.priority
                                        ? candidate.priority
                                        : 0}
                                      {"  "}
                                    </span> */}
                                  </p>
                                </div>
                              </div>
                              <div className="col-md-5 text-right jobopenings-btn">
                                <div
                                  className="btn-outline mb-2 candidate-search apply-now"
                                  onClick={() => applyFunction(candidate)}
                                >
                                  Apply Now
                                </div>
                              </div>
                            </div>
                            <div className="crmPost pt-2">
                              <div className="row">
                                <div className="col-md-12">
                                  <p className="d-lg-flex align-items-center">
                                    <span>
                                      Posted on :{" "}
                                      {formatDateToCustomFormat(
                                        candidate.created_on
                                      )}
                                    </span>
                                    <span className="d-none d-lg-block">|</span>
                                    <span>
                                      <b>
                                        No of Positions :{" "}
                                        {candidate.no_of_position
                                          ? candidate.no_of_position
                                          : 0}{" "}
                                      </b>
                                    </span>
                                    <span className="align-items-center pl-0 ms-auto text-uppercase">
                                      <b>
                                        <FaMapPin
                                          title="location"
                                          className="me-1 text-danger"
                                        />{" "}
                                        {candidate.location
                                          ? candidate.location
                                          : "Not Available"}
                                      </b>
                                    </span>
                                  </p>
                                </div>
                                <div className="col-md-3 dEnd justify-content-between"></div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
        {applyResume && (
          <ApplyNowPopup
            closePopup={() => setApplyResume(false)}
            position={positionData}
            jobSkills={jobSkills}
            siteId={window.location.pathname.split("/").pop()}
          />
        )}
      </div>
    </>
  );
}

export default ApplyNow;
